import type { ColumnConfig } from '@/shared/types/table';

/**
 * Si la columna puede mostrar el control de fijar/bloquear y alternar `locked`.
 * Resuelve `column.lockable` explícito frente al valor por tabla (`columnsLockable`).
 */
export function isColumnLockable<T>(
  column: ColumnConfig<T>,
  tableColumnsLockable?: boolean,
): boolean {
  const tableAllows = tableColumnsLockable !== undefined ? tableColumnsLockable : true;
  return column.lockable !== undefined ? column.lockable : tableAllows;
}
